import axios from "axios";
import GLOBAL from "../../Global.js";

export default class FacturadorService {
  getCatalogos(person) {
    var url1 = GLOBAL.API_GET_LISTA_CATALOGO_MEXICO;
    return axios
      .get(url1.trim(), {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d.data)
      .catch((error) => console.log(error));
  }

  getParametros(person) {
    var url1 = GLOBAL.API_GET_LISTA_ATRIBUTOS_EMPRESA;
    return axios
      .get(url1.trim(), {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d.data)
      .catch((error) => console.log(error));
  }

  getListaMovimientosParaFacturar(
    person,
    fechainicio,
    fechafin,
    cliente,
    documentos,
    search
  ) {
    var url1 =
      GLOBAL.API_GET_REPORTE_VENTAS_PARA_FACTURAR +
      "?fechainicio=" +
      fechainicio +
      ":00.000" +
      "&fechafin=" +
      fechafin +
      ":59.999" +
      "&tipo=" +
      documentos +
      "&cliente=" +
      cliente;
    if (search != null && Object.keys(search).length !== 0) {
      url1 =
        url1 + "&search[value]=" + encodeURIComponent(JSON.stringify(search));
    }

    return axios
      .get(url1, {
        timeout: 30000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d.data)
      .catch((error) => console.log(error));
  }

  crearFactura40Mexico(person, request) {
    var url1 = GLOBAL.API_CREAR_VENTA_MEXICO_ELECTRONICA;

    return axios
      .post(url1.trim(), request, {
        timeout: 60000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d)
      .catch((error) => console.log(error));
  }

   crearFacturaColombia(person, request) {
    var url1 = GLOBAL.API_CREAR_VENTA_COLOMBIA_ELECTRONICA;

    return axios
      .post(url1.trim(), request, {
        timeout: 60000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d)
      .catch((error) => console.log(error));
  }

  crearFactura40MexicoV2(person, request) {
    var url1 = GLOBAL.API_CREAR_VENTA_MEXICO_ELECTRONICA_V2;

    return axios
      .post(url1.trim(), request, {
        timeout: 60000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d)
      .catch((error) => console.log(error));
  }

  enviarFactura40Mexico(person, request) {
    var url1 = GLOBAL.API_ENVIAR_VENTA_MEXICO_ELECTRONICA;
    return axios
      .post(url1.trim(), request, {
        timeout: 300000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d)
      .catch((error) => console.log(error));
  }

  consultaFactura40Mexico(person, request) {
    var url1 = GLOBAL.API_CONSULTA_VENTA_MEXICO_ELECTRONICA;
    return axios
      .post(url1.trim(), request, {
        timeout: 300000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d)
      .catch((error) => console.log(error));
  }

  getFacturaPreview(person, uniqueid) {
    var url1 =
      GLOBAL.API_PREVIEW_FACTURA_ELECTRONICA +
      "/" +
      person.empresas +
      "/" +
      uniqueid;
    return axios
      .get(url1.trim(), {
        timeout: 300000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d)
      .catch((error) => console.log(error));
  }

  generarDescuento(person, request) {
    var url1 = GLOBAL.API_GENERA_DESCUENTO_FACTURA;
    return axios
      .put(url1.trim(), request, {
        timeout: 300000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d)
      .catch((error) => console.log(error));
  }

  enviarCancelacionFactura(person, request) {
    if (GLOBAL.COUNTRY == "MX") {
      var url1 = GLOBAL.API_CANCELAR_FACTURA_MEXICO_ELECTRONICA;
      return axios
        .put(url1.trim(), request, {
          timeout: 300000,
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Basic " + person.token,
            Environment: person.empresas,
          },
        })
        .then((d) => d)
        .catch((error) => console.log(error));
    } else {
      var url1 = GLOBAL.API_CANCELAR_FACTURA_COLOMBIA_ELECTRONICA;
      return axios
        .post(url1.trim(), request, {
          timeout: 300000,
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Basic " + person.token,
            Environment: person.empresas,
          },
        })
        .then((d) => d)
        .catch((error) => console.log(error));
    }
  }

  enviarInactivacionFactura(person, request) {
    if (GLOBAL.COUNTRY == "MX") {
      var url1 = GLOBAL.API_INACTIVAR_FACTURA_MEXICO_ELECTRONICA;
      return axios
        .put(url1.trim(), request, {
          timeout: 300000,
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Basic " + person.token,
            Environment: person.empresas,
          },
        })
        .then((d) => d)
        .catch((error) => console.log(error));
    }
  }

  enviarCambioOpcionesFactura(person, request) {
    if (GLOBAL.COUNTRY == "MX") {
      var url1 = GLOBAL.API_OPCIONES_FACTURA_MEXICO_ELECTRONICA;
      return axios
        .put(url1.trim(), request, {
          timeout: 300000,
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Basic " + person.token,
            Environment: person.empresas,
          },
        })
        .then((d) => d)
        .catch((error) => console.log(error));
    }
  }

  getProductos(person) {
    var url1 = GLOBAL.API_GET_LISTA_ALL_PRODUCTOS_MEXICO;
    return axios
      .get(url1.trim(), {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d.data)
      .catch((error) => console.log(error));
  }

  crearFacturaPOSMexico(person, request) {
    var url1 = GLOBAL.API_CREAR_VENTA_POS_MEXICO_ELECTRONICA;

    return axios
      .post(url1.trim(), request, {
        timeout: 60000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d)
      .catch((error) => console.log(error));
  }

  // === NUEVO: obtener precios por cliente ===
  getPreciosCliente(person, clienteId) { 
    var url1 = GLOBAL.API_PRODUCTO_PRECIO_CLIENTE_LISTA+"/"+clienteId;

    return axios
      .get(url1.trim(), {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d.data)
      .catch((error) => console.log(error));
  }

  // === NUEVO: guardar/actualizar precio de cliente-producto ===
  guardarPrecioCliente(person, payload) {
     var url1 = GLOBAL.API_PRODUCTO_PRECIO_CLIENTE_CREAR
     
    return axios
      .post(url1.trim(), payload, {
        timeout: 60000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d)
      .catch((error) => console.log(error));
  }


    // === NUEVO: guardar/actualizar precio de cliente-producto ===
  eliminarPrecioCliente(person, payload) {
     var url1 = GLOBAL.API_PRODUCTO_PRECIO_CLIENTE_ELIMINAR
     
    return axios
      .post(url1.trim(), payload, {
        timeout: 60000,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Basic " + person.token,
          Environment: person.empresas,
        },
      })
      .then((d) => d)
      .catch((error) => console.log(error));
  }

}
